import { css } from '@emotion/react';

import { colors, screens, space } from '../shared/styles';

const mobileMedia = `@media (max-width: calc(${screens.md} - 1px))`;

export const rootStyles = css`
  background: ${colors.light[100]};
  border-bottom: 1px solid ${colors.gray[300]};
  border-top: 1px solid ${colors.gray[300]};
  position: sticky;
  transition: box-shadow 160ms ease;
  z-index: 20;

  &[data-stuck='true'] {
    box-shadow: 0 2px 8px rgba(26, 32, 44, 0.08);
  }
`;

/** Zero-height marker at the nav's resting position; see useStuck. */
export const sentinelStyles = css`
  height: 0;
`;

export const scrollAreaStyles = css`
  position: relative;
  min-width: 0;

  &::before,
  &::after {
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    width: ${space[12]};
    content: '';
    opacity: 0;
    pointer-events: none;
    transition: opacity 120ms ease;
  }

  &::before {
    left: 0;
    background: linear-gradient(
      to right,
      ${colors.light[100]} 10%,
      rgba(255, 255, 255, 0)
    );
  }

  &::after {
    right: 0;
    background: linear-gradient(
      to left,
      ${colors.light[100]} 10%,
      rgba(255, 255, 255, 0)
    );
  }

  &[data-can-scroll-left='true']::before,
  &[data-can-scroll-right='true']::after {
    opacity: 1;
  }
`;

export const listStyles = css`
  display: flex;
  gap: ${space[2]};
  list-style: none;
  margin: 0;
  max-width: 100%;
  min-width: 0;
  overscroll-behavior-inline: contain;
  overflow-x: auto;
  padding: ${space[2]} 0;
  scroll-padding-inline: ${space[8]};
  scrollbar-width: none;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  > li {
    flex: 0 0 auto;
  }
`;

export const linkStyles = css`
  align-items: center;
  background: ${colors.light[100]};
  border: 1px solid ${colors.gray[400]};
  border-radius: 999px;
  color: ${colors.gray[800]};
  display: inline-flex;
  min-height: 2.5rem;
  padding: 0 ${space[4]};
  text-decoration: none;
  transition: background-color 120ms ease, border-color 120ms ease;
  white-space: nowrap;

  &:hover {
    background: ${colors.gray[100]};
    border-color: ${colors.gray[600]};
    color: ${colors.gray[900]};
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid ${colors.olive[500]};
    outline-offset: 2px;
  }

  &[aria-current='location'] {
    background: ${colors.olive[100]};
    border-color: ${colors.olive[300]};
    color: ${colors.olive[900]};
  }

  ${mobileMedia} {
    min-height: 2.75rem;

    > span {
      font-size: 0.9375rem;
    }
  }
`;
